import { RootState } from 'store/store';

export const getTicketsLoader = (state: RootState) => state.ticketRedux.loading;

export const getTicketsLoadingMore = (state: RootState) => state.ticketRedux.loadingMore;

export const getTicketUpdating = (state: RootState) => state.ticketRedux.updating;

export const getTickets = (state: RootState) => state.ticketRedux.tickets;

export const getActiveTicket = (state: RootState) => state.ticketRedux.activeTicket;

export const getActiveTicketNotificationsLength = (state: RootState) =>
	state.ticketRedux.activeTicket?.notifications?.length ?? 0;

export const getIsTicketUpdate = (state: RootState) => state.ticketRedux.isTicketUpdate;

export const getIsTyping = (state: RootState) => state.ticketRedux.isTyping;

export const getVoiceMode = (state: RootState) => state.ticketRedux.voiceMode;

export const getIsRecording = (state: RootState) => state.ticketRedux.isRecording;

export const getIsSocketConnected = (state: RootState) => state.ticketRedux.isSocketConnected;

export const getIsStreaming = (state: RootState) => state.ticketRedux.isStreaming;

export const getIsSummaryLoading = (state: RootState) => state.ticketRedux.isSummaryLoading;

// shows loader
export const getIsUsecasesLoading = (state: RootState) => state.ticketRedux.isUsecasesLoading;

// shows if initial use cases requests are still running
export const getIsUseCasesGenerating = (state: RootState) => state.ticketRedux.isUseCasesGenerating;

// shows loader
export const getIsTestCasesLoading = (state: RootState) => state.ticketRedux.isTestCasesLoading;

// shows if initial test cases requests are still running
export const getIsTestCasesGenerating = (state: RootState) =>
	state.ticketRedux.isTestCasesGenerating;

export const getIsNotificationLoading = (state: RootState) =>
	state.ticketRedux.isNotificationLoading;

export const getIsReportLoading = (state: RootState) => state.ticketRedux.isReportLoading;

// export const getNeedLoadUseCases = (state: RootState) => state.ticketRedux.needLoadUseCases;

export const getActiveStep = (state: RootState) => state.ticketRedux.activeStep;

export const getActiveSubStage = (state: RootState) => state.ticketRedux.activeSubStage;

export const getDetailedViewTicketSummary = (state: RootState) =>
	state.ticketRedux.detailedViewTicketSummary;

export const getIsReportAnIssueMode = (state: RootState) => state.ticketRedux.reportAnIssueMode;

export const getIsPaymentMode = (state: RootState) => state.ticketRedux.paymentMode;

export const getPaymentModalInfo = (state: RootState) => state.ticketRedux.paymentModalInfo;

export const getIsTariffPlansModalOpen = (state: RootState) =>
	state.ticketRedux.isTariffPlansModalOpen;

export const getEditMode = (state: RootState) => state.ticketRedux.editMode;

export const getTicketHistory = (state: RootState) => state.ticketRedux.ticketChanges;

export const getActiveHistoryItem = (state: RootState) => state.ticketRedux.activeHistoryItem;

export const getIsTicketHistoryLoading = (state: RootState) => state.ticketRedux.isHistoryLoading;

export const getHistoryMode = (state: RootState) => state.ticketRedux.historyMode;

export const getSidebarView = (state: RootState) => state.ticketRedux.sidebarView;

export const getIsChatOpen = (state: RootState) => state.ticketRedux.isChatOpen;

export const getIsTicketShare = (state: RootState) =>
	Boolean(state.ticketRedux.activeTicket?.permissions?.length);

export const getIsTicketNavigationButtonsAvailable = (state: RootState) =>
	state.ticketRedux.activeTicket?.permissions?.length
		? state.ticketRedux.activeTicket?.permissions
				?.map((permission) => permission.ticketCurrentStep)
				?.includes(null)
		: true;

export const getIsStepperStagesOpen = (state: RootState) => state.ticketRedux.isStepperStagesOpen;

export const getIsStepperSubStagesOpen = (state: RootState) =>
	state.ticketRedux.isStepperSubStagesOpen;

export const getActiveTicketSummaries = (state: RootState) =>
	state.ticketRedux.activeTicket?.ticketSummaries;
